import L from 'leaflet'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { AreaViewBase, type AreaViewBaseOptions } from '../AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { Layer } from 'leaflet'

/*
 * @Author: Yolo
 * @Date: 2024-06-24 14:51:54
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-06-24 15:48:55
 * @Desc 高风险碰撞区域/碍航网具
 */
class CollisionRiskSymbol extends AreaViewBase {
  lyGroup = null
  hash = {}
  layerHash = {}
  layerHashName = {}
  _zoomend = false
  _tempAreaArray: any[] = []
  dataType = {
    obstaclearea: [
      {
        name: '碍航网具-区域一',
        type: 'Poly',
        points: [
          ['35.208611', '119.966389'],
          ['35.208611', '120.011944'],
          ['35.201389', '120.018889'],
          ['35.173056', '120.020833'],
          ['35.173611', '120.035556'],
          ['35.150556', '120.037778'],
          ['35.149722', '119.987500'],
          ['35.199167', '119.966389'],
        ],
      },
      {
        name: '碍航网具-区域二',
        type: 'Poly',
        points: [
          ['35.171667', '119.901111'],
          ['35.168611', '119.951389'],
          ['35.118611', '119.947778'],
          ['35.120000', '119.886667'],
        ],
      },
      {
        name: '碍航网具-区域三',
        type: 'Poly',
        points: [
          ['35.096111', '119.879444'],
          ['35.095000', '119.955278'],
          ['35.055556', '119.946667'],
          ['35.055556', '119.867778'],
        ],
      },
      {
        name: '碍航网具-区域四',
        type: 'Poly',
        points: [
          ['35.106667', '119.798056'],
          ['35.107222', '119.844167'],
          ['35.050000', '119.823889'],
          ['35.053611', '119.774722'],
        ],
      },
      {
        name: '碍航网具-区域五',
        type: 'Poly',
        points: [
          ['35.0419441', '119.605278'],
          ['35.0366671', '119.747500'],
          ['35.0063891', '119.747778'],
          ['35.0050001', '119.671944'],
          ['35.0188891', '119.602222'],
        ],
      },
    ],
    collisionRisk: [
      {
        name: '秦皇岛东南部水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['39.698444', '119.638978'],
          ['39.668822', '119.660083'],
          ['39.757067', '119.864383'],
          ['39.786650', '119.839739'],
        ],
      },
      {
        name: '曹妃甸东部水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['38.759444', '118.750000'],
          ['38.729444', '119.123611'],
          ['38.837500', '119.136111'],
          ['38.863056', '118.768056'],
        ],
      },
      {
        name: '黄骅东北部水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['38.537500', '118.500278'],
          ['38.486944', '118.510833'],
          ['38.448056', '118.100000'],
          ['38.594722', '118.100000'],
          ['38.594722', '118.140833'],
          ['38.506389', '118.140833'],
        ],
      },
      {
        name: '旅顺深水航路商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['39.257000', '121.010667'],
          ['38.946000', '120.950833'],
          ['38.956000', '120.841000'],
          ['39.272500', '120.873667'],
        ],
      },
      {
        name: '大连湾及大窑湾水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['38.893333', '121.896000']],
        radius: 9,
      },
      {
        name: '老铁山水道商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['38.597611', '120.920806']],
        radius: 6.5,
      },
      {
        name: '老铁山水道东部水域商渔碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['38.433333', '121.016667'],
          ['38.500000', '121.066667'],
          ['38.450000', '121.500000'],
          ['38.275000', '121.408333'],
        ],
      },
      {
        name: '长山水道西部水域商渔碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['38.000000', '120.266667'],
          ['38.141667', '120.266667'],
          ['38.141667', '120.516667'],
          ['38.000000', '120.516667'],
        ],
      },
      {
        name: '长山水道东部水域商渔碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['37.921833', '121.368667'],
          ['37.860833', '121.350000'],
          ['37.919667', '121.049167'],
          ['37.981667', '121.070500'],
        ],
      },
      {
        name: '威海北部水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['37.716000', '122.247167'],
          ['37.628667', '122.213333'],
          ['37.707000', '121.909000'],
          ['37.794333', '121.942333'],
        ],
      },
      {
        name: '成山头北部水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['37.681806', '122.678306']],
        radius: 6.5,
      },
      {
        name: '石岛东南通航水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['36.532500', '122.746000'],
          ['36.977167', '122.746000'],
          ['36.977167', '122.897500'],
          ['36.532500', '122.897500'],
        ],
      },
      {
        name: '威海南部水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['36.785000', '122.630833'],
          ['36.436333', '122.263000'],
          ['36.606667', '122.101333'],
          ['36.843833', '122.574833'],
        ],
      },
      {
        name: '射阳河口水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['33.871611', '120.590694']],
        radius: 4.5,
      },
      {
        name: '南通吕四渔港东侧水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['32.123500', '122.431500'],
          ['32.390167', '122.431500'],
          ['32.390167', '122.638500'],
          ['32.123500', '122.638500'],
        ],
      },
      {
        name: '长江口北部水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['32.231667', '122.991667'],
          ['32.231667', '122.920222'],
          ['31.636667', '122.920222'],
          ['31.636667', '122.991667'],
        ],
      },
      {
        name: '海礁西侧航路水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['30.569167', '122.975167'],
          ['30.810000', '122.975167'],
          ['30.810000', '123.031167'],
          ['30.569167', '123.031167'],
        ],
      },
      {
        name: '小板门及宁波舟山港附近水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['29.904333', '122.663333'],
          ['29.900167', '122.616667'],
          ['30.347333', '122.581500'],
          ['30.351500', '122.628000'],
        ],
      },
      {
        name: '外甩礁东侧附近水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['30.165889', '123.006194']],
        radius: 5.5,
      },
      {
        name: '浙江沿海外航路象山段水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['29.403333', '122.551000'],
          ['29.065000', '122.335667'],
          ['29.105167', '122.251667'],
          ['29.441500', '122.467000'],
        ],
      },
      {
        name: '浙江沿海西航路温岭段水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['28.250000', '121.793667'],
          ['28.088000', '121.635333'],
          ['28.118333', '121.595833'],
          ['28.282833', '121.751333'],
        ],
      },
      {
        name: '洞头附近水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['27.801833', '121.354833'],
          ['27.680500', '121.208833'],
          ['27.715667', '121.175667'],
          ['27.836167', '121.321000'],
        ],
      },
      {
        name: '鳌江口附近水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['27.551833', '120.856667'],
          ['27.420000', '120.744000'],
          ['27.442833', '120.712667'],
          ['27.574167', '120.824833'],
        ],
      },
      {
        name: '东引岛东南水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['26.207250', '120.661722'],
          ['26.122528', '120.780083'],
          ['25.943472', '120.646611'],
          ['26.027000', '120.528111'],
        ],
      },
      {
        name: '牛山岛东侧水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['25.240333', '119.878333'],
          ['25.268000', '119.829833'],
          ['25.465000', '119.981167'],
          ['25.437333', '120.029667'],
        ],
      },
      {
        name: '南日岛东南水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['25.044667', '119.540500'],
          ['25.081000', '119.513667'],
          ['25.209500', '119.704333'],
          ['25.173500', '119.730667'],
        ],
      },
      {
        name: '乌丘屿西南水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['24.893694', '119.384778'],
          ['24.838028', '119.426667'],
          ['24.728583', '119.278194'],
          ['24.783333', '119.235361'],
        ],
      },
      {
        name: '厦门湾口东碇附近水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['24.087833', '118.240667'],
          ['24.121833', '118.212667'],
          ['24.256167', '118.383333'],
          ['24.221667', '118.412500'],
        ],
      },
      {
        name: '浮头湾口水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['23.722167', '117.742333'],
          ['23.748333', '117.719667'],
          ['23.898167', '117.911500'],
          ['23.871833', '117.934500'],
        ],
      },
      {
        name: '粤东表角水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['23.202667', '116.902000'],
          ['23.072500', '116.746667'],
          ['23.117333', '116.703833'],
          ['23.248000', '116.859333'],
        ],
      },
      {
        name: '粤东遮浪角水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['22.510000', '115.530500'],
          ['22.429167', '115.264500'],
          ['22.554500', '115.222500'],
          ['22.635167', '115.490667'],
        ],
      },
      {
        name: '珠江口担杆水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['22.106889', '114.211194']],
        radius: 4,
      },
      {
        name: '珠江口桂山水域商渔船碰撞高风险警示区,',
        type: 'Circle',
        points: [['22.136111', '113.809111']],
        radius: 4,
      },
      {
        name: '琼州海峡北水道北进口水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['20.522194', '110.968000']],
        radius: 4,
      },
      {
        name: '琼州海峡中水道的东进口水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['20.233500', '111.084667'],
          ['20.233167', '110.962833'],
          ['20.278167', '110.956833'],
          ['20.322000', '111.073667'],
        ],
      },
      {
        name: '琼州海峡西口水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['20.139389', '109.851694']],
        radius: 5,
      },
      {
        name: '涠洲岛西航路南段水域商渔船碰撞高风险警示区',
        type: 'Poly',
        points: [
          ['20.623333', '109.457500'],
          ['20.525333', '109.359000'],
          ['20.789667', '109.093833'],
          ['20.883500', '109.193667'],
        ],
      },
      {
        name: '钦州湾南部水域商渔船碰撞高风险警示区',
        type: 'Circle',
        points: [['21.460694', '108.635306']],
        radius: 4,
      },
    ],
  }
  constructor(map: MyMap, options: Partial<AreaViewBaseOptions>) {
    super(map, { minzoom: 2, maxzoom: 18, ...options, isZoomEnd: false })
    this._data = this.dataType[options.type]
    this._data.forEach((item: { name: string | number }) => {
      this.hash[item.name] = item
    })
    this.polyNameChange()
  }
  _show() {
    this.bounds = []
    Object.keys(this.hash).forEach((key) => {
      let layer: any
      if (this.hash[key].type == 'Poly') {
        layer = L.polygon(
          [
            this.hash[key].points.map((c: L.LatLngExpression) => {
              return CanvasShipUtils.GPSEncryptByMapToLatLng(c, this._map)
            }),
          ],
          {
            fillOpacity: 0.4,
            opacity: 0.4,
            weight: 1,
            color: '#ff0000',
          }
        )
        layer._type = 'poly'
        this.bounds = this.bounds.concat(this.hash[key].points)
      }
      if (this.hash[key].type == 'Circle') {
        layer = L.circle(
          CanvasShipUtils.GPSEncryptByMapToLatLng(
            this.hash[key].points[0],
            this._map
          ),
          {
            radius: this.hash[key].radius * 1852,
            fillOpacity: 0.4,
            opacity: 0.4,
            weight: 1,
            color: '#ff0000',
          }
        )
        layer._type = 'circle'
      }
      this.layerHash[key] = layer
      this._map.addLayer(layer)

      this.layerHashName[key] = this.showName(layer, key)
      this.layerHashName[key] && this._map.addLayer(this.layerHashName[key])
    })
    this._map.fitBounds(this.bounds)
  }

  _hide() {
    try {
      for (const item in this.layerHashName) {
        const layer = this.layerHashName[item]
        if (layer) {
          if (this._map.hasLayer(layer)) this._map.removeLayer(layer)
          delete this.layerHashName[item]
        }
      }
      for (const item in this.layerHash) {
        this._map.removeLayer(this.layerHash[item])
        delete this.layerHash[item]
      }
    } catch (e) {
      console.log(e)
    }
  }

  //  区域名称绘制逻辑
  //  1:当前可视范围内区域名称重绘
  //  2:处于编辑的区域屏蔽展示
  //  3:事件调整 缩放执行延迟添加
  ///
  polyNameChange() {
    this._map.on('zoomend', () => {
      this._zoomend = true
    })
    this._map.on('moveend', () => {
      this._tempAreaArray = []
      for (const item in this.layerHashName) {
        const ly = this.layerHashName[item]
        ly && this._map.removeLayer(ly)
        if (this.layerHash[item]) {
          this.layerHash[item] && this.layerHash[item].redraw()
          const lbounds = this.layerHash[item].getBounds()
          if (lbounds.isValid()) {
            if (this._map.getBounds().intersects(lbounds)) {
              this.layerHashName[item] = this.showName(
                this.layerHash[item],
                item
              )
              //缩放延迟执行添加
              if (!this._zoomend)
                this.layerHashName[item] &&
                  this._map.addLayer(this.layerHashName[item])
              else {
                this._tempAreaArray.push(this.layerHashName[item])
              }
            }
          }
        }
      }
      //延迟绘制
      setTimeout(() => {
        this._tempAreaArray.forEach((item) => {
          item && this._map.addLayer(item)
        })
      }, 0)
      this._zoomend = !1
    })
  }

  showName(p: Layer, name = '') {
    const color = this._map.mapType != 'MT_SATELLITE' ? '#333' : '#fff'
    return CommUtils.getFeatureLabel(p, name, {
      attributes: {
        fill: color,
        xShift: 0,
      },
    } as any)
  }
}
const collisionRiskSymbol = (
  map: MyMap,
  options: Partial<AreaViewBaseOptions>
) => new CollisionRiskSymbol(map, options)
export { collisionRiskSymbol, CollisionRiskSymbol }
